import {Pipe, PipeTransform} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import moment from "jalali-moment";

@Pipe({
  name: 'time',
  standalone: false,
  pure: false
})
export class TimePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {
  }

  transform(date: string, format: string): string {
    if (date === undefined || date === null || date.trim() === '') {
      return '';
    }
    try {
      switch (this.translateService.currentLang) {
        case 'ar':
          return moment(date, 'YYYY/MM/DD HH:mm Z').locale(this.translateService.currentLang).format(format);
        case 'fa':
        case 'en':
        case 'es':
        case 'tr':
        case 'ja':
        default:
          return moment(date, 'YYYY/MM/DD HH:mm Z').locale(this.translateService.currentLang).format(format);
      }
    } catch (e) {
      return '';
    }
  }
}
